
import React from 'react';

function Support() {
  return (
    <div>
      <h1>Support Page</h1>
    </div>
  );
}

export default Support;
